import React from "react";
import { useNavigate } from "react-router-dom";
import {
  BookOpenIcon,
  LanguageIcon,
  TrophyIcon,
  Cog6ToothIcon,
} from "@heroicons/react/24/outline";
import { ScrollTextIcon } from "lucide-react";

const menuItems = [
  { id: "Belajar", path: "/learn", icon: <BookOpenIcon className="w-8 h-8" /> },
  {
    id: "Aksara",
    path: "/aksara",
    icon: (
      <span
        className="w-8 h-8 flex items-center justify-center font-bold pb-2"
        style={{
          fontFamily: "Noto Sans Batak",
          fontSize: "2rem",
          lineHeight: 1,
        }}
      >
        ᯀ
      </span>
    ),
  },
  {
    id: "Terjemahan",
    path: "/terjemahan",
    icon: <LanguageIcon className="w-8 h-8" />,
  },
  {
    id: "Sastra & Budaya",
    path: "/sastra-budaya",
    icon: <ScrollTextIcon className="w-8 h-8" />,
  },
  {
    id: "Pencapaian",
    path: "/achievement",
    icon: <TrophyIcon className="w-8 h-8" />,
  },
  {
    id: "Pengaturan",
    path: "/settings",
    icon: <Cog6ToothIcon className="w-8 h-8" />,
  },
];

const BottomNav = ({ currentSection, setCurrentSection, darkMode }) => {
  const navigate = useNavigate();
  const handleMenuClick = (item) => {
    setCurrentSection(item.id);
    if (item.path) {
      navigate(item.path);
    }
  };
  return (
    <nav
      className={`fixed bottom-0 left-0 right-0 z-40 flex justify-around items-center h-20 border-t-2 ${
        darkMode ? "bg-gray-800 border-gray-700" : "bg-white border-gray-200"
      }`}
    >
      {menuItems.map((item) => (
        <button
          key={item.id}
          onClick={() => handleMenuClick(item)}
          className={`flex flex-col items-center justify-center rounded-lg px-2 py-1 focus:outline-none ${
            item.id === currentSection
              ? darkMode
                ? "bg-blue-900/30 text-blue-300 border-2 border-blue-700"
                : "bg-blue-50 text-blue-600 border-2 border-blue-200"
              : darkMode
              ? "text-gray-300 hover:bg-gray-700/50"
              : "text-gray-600 hover:bg-gray-50"
          }`}
        >
          {item.icon}
        </button>
      ))}
    </nav>
  );
};

export default BottomNav;
